module.exports = __webpack_public_path__ + "static/media/become_an_agent.aeee3901.svg";